export default __webpack_public_path__ + "static/media/0320.47bf8d55.jpg";